export default "__VITE_ASSET__8363f3fa__"